import React from 'react';
import { cn } from '@/utils/cn';
import Image from '@/components/common/Image';

interface SecurityFeatureCardProps extends React.HTMLAttributes<HTMLDivElement> {
  icon: string;
  title: string;
  description: string;
  backgroundColor?: string;
  iconWidth?: number;
  iconHeight?: number;
}

const SecurityFeatureCard = ({
  icon,
  title,
  description,
  backgroundColor = "#1A1A1A",
  iconWidth = 36,
  iconHeight = 36,
  className,
  ...props
}: SecurityFeatureCardProps) => {
  return (
    <div
      className={cn("rounded-xl p-6 md:p-7 flex flex-col h-full", className)}
      style={{ backgroundColor }}
      {...props}
    >
      {/* Feature Icon */}
      <div className="mb-4 flex justify-center md:justify-start">
        <Image
          src={icon}
          alt={`${title} icon`}
          width={iconWidth}
          height={iconHeight}
          className="md:w-[56px] md:h-[56px]"
        />
      </div>

      {/* Feature Title */}
      <h3 className="text-lg md:text-xl font-bold mb-3">{title}</h3>

      {/* Feature Description */}
      <p className="text-gray-400 text-sm">{description}</p>
    </div>
  );
};

export default SecurityFeatureCard;